export interface IRooms {
  minPrice: string;
  roomsCount: string;
}

/**
 * Варианты комнатности описаны в ERooms – types/filter
 */
export enum ERoomsCount {
  Studio = 9,
  OneRoom = 1,
  TwoRoom = 2,
  ThreeRoom = 3,
  FourRoom = 4,
  FiveRoom = 5,
}
